export const EPLEDGE_REQUEST_BOOK = "EPLEDGE_REQUEST_BOOK";
export const EPLEDGE_REQUEST_BOOK_ERROR = "EPLEDGE_REQUEST_BOOK_ERROR";
export const EPLEDGE_REQUEST_BOOK_HIDE_ERROR = "EPLEDGE_REQUEST_BOOK_HIDE_ERROR";
export const EPLEDGE_REQUEST_BOOK_START_LOADER = "EPLEDGE_REQUEST_BOOK_START_LOADER";
export const EPLEDGE_REQUEST_BOOK_STOP_LOADER = "EPLEDGE_REQUEST_BOOK_STOP_LOADER";
